import { render, staticRenderFns } from "./theTail.vue?vue&type=template&id=f6655d40&scoped=true"
import script from "./theTail.vue?vue&type=script&lang=js"
export * from "./theTail.vue?vue&type=script&lang=js"
import style0 from "./theTail.vue?vue&type=style&index=0&id=f6655d40&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f6655d40",
  null
  
)

export default component.exports